/* eslint-disable react/forbid-prop-types */
import PropTypes from 'prop-types';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { signOut } from 'helpers/cookies';
import breakPoints from 'helpers/Styles';
import React, { useEffect, useState, useContext } from 'react';
import Error from '../ExceptionsHandling/Error';
import OrderList from './OrderList/index';
import EditDetails from './EditDetails/index';
import MyDetails from './MyDetails/index';
import OrderHistoryTable from './OrderHistoryTable';
import RigsTable from './RigsTable';
import RecentOrdersTable from './RecentOrdersTable';
import RigSection from './RigSection';
import ConfirmDialog from './ConfirmDialog';
import { StorefrontContext } from 'providers/storefront';

const Account = ({ customer, token, error, handleLogout, refetch }) => {
  const { profileTabIndex, isLoggedIn } = useContext(StorefrontContext);
  const isNewDesign = true;
  const [index, setIndex] = useState(profileTabIndex);
  const [isOpenMenu, setIsOpenMenu] = useState(true);
  const [rig, setRig] = useState(null);
  const [isConfirmLogout, setIsConfirmLogout] = useState(false);

  useEffect(() => {
    setIndex(profileTabIndex);
  }, [profileTabIndex]);

  const rigs = [
    {
      id: 30001394,
      title: 'Hypergate Elite',
      description: 'Aesthetic focused',
      date_ordered: '01/01/2022',
      date_delivered: '08/01/2022',
      price: 2590.0,
      builder: 'Alex',
      tester: 'Anthony',
      status: 'processing',
      cpu_score: 18905,
      gpu_score: 12897,
      performance: {
        graphics: {
          resolutions: [
            { item: '1080p', value: 16 },
            { item: '1440p', value: 13 },
            { item: '4K', value: 10 },
          ],
        },
        processing: 15,
        ram_speed: 12,
        application_load_speed: 14,
        style: [
          { name: 'Light it up', isSelected: true },
          { name: 'in between', isSelected: false },
          { name: 'refined', isSelected: false },
        ],
      },
      components: [
        {
          title: 'your core build',
          items: [
            { label: 'CHASSIS', value: 'NZXT H510 Elite - Black' },
            { label: 'MOTHERBOARD', value: 'Gigabyte X570 Aorus Elite' },
            {
              label: 'CPU',
              value: 'AMD Ryzen 7 5800X | 4.7 GHz | 8 Cores 16 Threads',
            },
            {
              label: 'GRAPHICS CARD',
              value: 'Asus RTX 3070 KO Gaming OC - 8GB V2',
            },
            { label: 'RAM', value: '32GB Gigabyte Aorus RGB 3733MHz (4x8GB)' },
            {
              label: 'CPU COOLING SYSTEM',
              value: 'NZXT Kraken Z63 | 280mm Radiator | LED Display',
            },
          ],
        },
        {
          title: 'YOUR EXTRAS',
          items: [
            {
              label: 'THERMAL compound',
              value: 'Premium Enthusiast Grade Thermal Compound',
            },
            {
              label: 'FIRST HARD DRIVE',
              value: '4TB Western Digital 5400RPM 3.5"',
            },
            {
              label: 'SECOND HARD DRIVE',
              value: null,
            },
            {
              label: 'POWER SUPPLY UNIT',
              value: '850W NZXT C Series 80+ Gold - Modular',
            },
          ],
        },
        {
          title: 'YOUR STYLING',
          items: [
            {
              label: 'CHASSIS FANS',
              value: '2 x 140mm plus 2 x 120mm NZXT Aer 2 Fans',
            },
            {
              label: 'CASE LIGHTING',
              value: 'NZXT HUE 2 RGB Lighting included in case',
            },
            {
              label: 'CUSTOM CABLE SLEEVES',
              value: 'Cable Sleeve Kit - Classic Black',
            },
            {
              label: 'CUSTOM GLASS LASER ENGRAVING',
              value: null,
            },
            {
              label: 'SINGLE LINE HEADING',
              value:
                'Component name that goes over two lines lorem ipsum dolor sit amet consectetur adipiscing elit sed do eiusmod. Component name that goes over two lines lorem ipsum dolor sit amet consectetur adipiscing elit sed do eiusmod',
            },
          ],
        },
        {
          title: 'YOUR ACCESSORIES',
          items: [
            {
              label: 'MICROSOFT OFFICE',
              value: null,
            },
            {
              label: 'VIRUS PROTECTION',
              value: null,
            },
            {
              label: 'PRECISION KEYBOARDS',
              value: null,
            },
            {
              label: 'PRECISION GAMING MOUSE',
              value: null,
            },
          ],
        },
      ],
    },
  ];
  const tabsData = [
    {
      id: 0,
      title: 'MY ACCOUNT',
      items: [
        {
          id: 0,
          item: 'ACCOUNT OVERVIEW',
          iconSrc: '/icons/account_tabs/icon-user.svg',
        },
        {
          id: 1,
          item: 'ACCOUNT DETAILS',
          iconSrc: '/icons/account_tabs/icon-user-settings.svg',
        },
        {
          id: 2,
          item: 'ORDER HISTORY',
          iconSrc: '/icons/account_tabs/icon-list.svg',
        },
        // {
        //   id: 3,
        //   item: 'MY RIGS',
        //   iconSrc: '/icons/account_tabs/icon-rig.svg',
        // },
        // {
        //   id: 4,
        //   item: 'SIGN OUT',
        //   iconSrc: '/icons/account_tabs/icon-signout.svg',
        // },
      ],
    },
  ];
  useEffect(() => {
    setEditMode(false);
  }, [index]);
  const handleOnSelect = (index) => {
    if (index === 3) {
      setIsConfirmLogout(true);
    }
  };

  const handleSignOut = () => {
    signOut();
    handleLogout();
  };

  const [editMode, setEditMode] = useState(false);

  const handleEdit = () => {
    setEditMode(true);
  };

  return isNewDesign ? (
    <>
      {isConfirmLogout && (
        <ConfirmDialog
          title={'Are you sure you want to logout?'}
          confirmText={'Logout'}
          onCancel={() => setIsConfirmLogout(false)}
          onConfirm={handleSignOut}
        />
      )}
      <div className="container">
        <div className="account_container">
          <nav className="sidebar_menu">
            {tabsData?.map((tabGroup, tabIndex) => (
              <div key={tabIndex} className="tab_item_list">
                <div
                  className="tab_group_title"
                  onClick={() => setIsOpenMenu((prev) => !prev)}
                >
                  <span>{tabGroup.title}</span>
                  <img draggable="false"
                    src={
                      isOpenMenu
                        ? '/icons/ChevronUp.svg'
                        : '/icons/ChevronDown.svg'
                    }
                    className="tab_menu_icon"
                    alt='menu_icon'
                  />
                </div>
                <div className="tab_list_buttons">
                  {tabGroup.items.map((tabItem, idx) => (
                    <button
                      key={idx}
                      onClick={() => {
                        if (idx === 3) {
                          handleOnSelect(idx);
                          return;
                        }
                        window.scrollTo(0, 0);
                        setIndex(idx);
                        setIsOpenMenu(false);
                      }}
                      className={`tab_item ${
                        idx === index ? 'active_tab' : ''
                      }`}
                    >
                      <span className="tab_icon">
                        <TabIcon svg={tabItem.iconSrc} />
                      </span>
                      {/* TABICON COMPONENT IS INSIDE THIS FILE */}
                      <span>{tabItem.item}</span>
                    </button>
                  ))}
                </div>
              </div>
            ))}
          </nav>
          <div id="main-content" className="tab_content w-full">
            {index === 0 && (
              <div>
                <div className="title">
                  welcome to the aftershock family, {customer?.firstName}
                </div>
                <p className="tab_description">
                  Keep track of your rig, and any other orders you have from us.
                  You can also check/edit your account details to ensure the
                  information we have is up-to-date.
                </p>
                <h2 className="recent_order">Recent Orders</h2>
                {customer?.orders?.edges?.length > 0 && (
                  <p>Here are your orders placed on our store</p>
                )}
                {/* <div className="my-account__content">
                  <OrderList
                    orders={customer?.orders ? customer?.orders : null}
                  />
                </div> */}
                {customer?.orders && (
                  <RecentOrdersTable
                    orders={customer?.orders ? customer?.orders : null}
                  />
                )}
              </div>
            )}

            {index === 1 && (
              <div>
                <div className="title">Hi, {customer?.firstName}</div>
                {customer && editMode ? (
                  <EditDetails
                    customer={customer}
                    token={token}
                    handleEdit={setEditMode}
                    editMode={editMode}
                    customerRefetch={refetch}
                  />
                ) : (
                  <MyDetails customer={customer} handleEdit={handleEdit} />
                )}
              </div>
            )}

            {index === 2 && (
              <div>
                <div className="title">Order History</div>
                {customer && (
                  <div>
                    <p className="tab_description">
                      Below, you can see the history of your purchases made from
                      Aftershock PC over the years!
                    </p>
                    <OrderHistoryTable
                      orders={customer?.orders ? customer?.orders : null}
                    />
                  </div>
                )}
              </div>
            )}
            {/* 
            {index === 3 && (
              <div className="w-full">
                {rig ? (
                  <RigSection
                    rig={rig}
                    handleBack={() => {
                      setRig(null);
                    }}
                  />
                ) : (
                  <div>
                    <div className="title">Your Rigs</div>
                    {customer && (
                      <div>
                        <p className="tab_description">
                          Lorem ipsum dolor sit amet, consectetur adipiscing
                          elit sed do eiusmod. Lorem ipsum dolor sit amet,
                          consectetur adipiscing elit sed do eiusmod.
                        </p>
                        <RigsTable
                          rigs={rigs}
                          getRig={(val) => {
                            setRig(val);
                            window.scrollTo(0, 0);
                          }}
                        />
                      </div>
                    )}
                  </div>
                )}
              </div>
            )} */}
          </div>
        </div>
      </div>
      <style jsx>
        {`
        .tab_description{
          font-family: 'Roboto-Medium';
          font-size: 16px;
          font-weight: 400;
          line-height: 24px;
          letter-spacing: 0em;
          text-align: left;
          color:#E4E4E4;
          margin-top:24px;
        }
        .w-full{
          width:100%;
        }
          .recent_order {
            font-family: 'Roboto-Medium';
            font-style: normal;
            font-weight: 600;
            font-size: 13px;
            line-height: 24px;
            text-transform: uppercase;
            color: #949494;
            margin-bottom: 16px;
            margin-top: 40px;
          }
          .container {
            max-width: 1440px;
            margin: 0 auto;
            // margin-top:48px;
          }
          .account_container {
            display: flex;
          }
          .sidebar_menu {
            display: flex;
            min-width: 368px;
            background-color: #242424;
            padding: 56px 24px 240px 48px;
          }
          .tab_item_list {
            padding: 0;
            margin: 0;
            width: 100%;
          }
          .tab_group_title {
            font-family: 'Roboto-Medium';
            font-size: 20px;
            font-weight: 600;
            line-height: 24px;
            letter-spacing: 0em;
            text-align: left;
            padding: 24px 0px;
            display: flex;
            gap: 8px;
            user-select: none;
          }
          .tab_item {
            border-radius: 2px;
            font-family: 'Roboto-Medium';
            font-size: 13px;
            font-weight: 600;
            line-height: 24px;
            letter-spacing: 0em;
            text-align: left;
            padding: 16px 20px;
            display: flex;
            gap: 12px;
            align-items: center;
            width: 100%;
            color: #e4e4e4;
            outline: none;
            border: none;
            background: transparent;
            opacity: 0.75;
            user-select: none;
          }
          .tab_item:hover {
            opacity: 1;
          }
          .active_tab {
            background-color: #141414;
            transition: background-color 0.5s ease-in-out;
            opacity: 1;
          }
          .tab_icon {
            width: 24px;
            display: flex;
            justify-content: center;
          }
          .tab_content {
            padding: 80px 64px 80px 32px;
            width:100%:
          }
          .title {
            font-family: big_noodle_titling;
            font-size: 39px;
            font-weight: 400;
            line-height: 48px;
            letter-spacing: 0em;
            text-align: left;
            padding: 0;
          }
          .tab_content .content {
            font-family: 'Roboto-Medium';
            font-size: 16px;
            line-height: 24px;
          }
          .tab_menu_icon {
            display: none;
          }
          @media (max-width: 991px) {
            .container{
              // margin-top:0;
            }
            .tab_menu_icon {
              display: block;
            }
            .sidebar_menu {
              position: fixed;
              top: 80px;
              min-width: 100%;
              overflow: hidden;
              padding: 16px;
              height: ${isOpenMenu ? 'auto' : '56px'};
              z-index:3;
            }
            .tab_group_title {
              padding: 0;
              cursor: pointer;
            }
            .tab_content {
              padding: 24px;
              margin-top: 56px;
            }
            .tab_list_buttons {
              margin-top: 24px;
              display: ${isOpenMenu ? 'block' : 'none'};
            }
          }
         

        `}
      </style>
    </>
  ) : (
    <>
      <Tabs defaultIndex={0} onSelect={handleOnSelect} className="my-account ">
        <TabList>
          <Tab>MY ORDERS</Tab>
          <Tab>MY DETAILS</Tab>
          <Tab>SIGN OUT</Tab>
        </TabList>
        <div className="tabpanel--container">
          <TabPanel>
            {/* {loading ? <Loader /> : null} */}
            {error ? <Error /> : null}
            {customer ? (
              <>
                <div className="my-account__header">
                  <h1 className="heading_style__hero">
                    Welcome to the Aftershock Family, {customer.firstName}
                  </h1>

                  <p>
                    Keep track of your Rig, and any other orders you have from
                    us.
                  </p>

                  <p>
                    You can also check/edit your account details to ensure the
                    information we have is up-to-date.
                  </p>
                  <h2 className="heading_style__primary">Your Orders</h2>
                  {customer?.orders?.edges?.length > 0 && (
                    <p>Here are your orders placed on our store</p>
                  )}
                </div>
                <div className="my-account__content">
                  <OrderList
                    orders={customer.orders ? customer.orders : null}
                  />
                </div>
              </>
            ) : null}
          </TabPanel>
          <TabPanel>
            {error ? <Error /> : null}
            {customer && editMode === false ? (
              <MyDetails customer={customer} handleEdit={handleEdit} />
            ) : (
              <EditDetails
                customer={customer}
                token={token}
                handleEdit={setEditMode}
                editMode={editMode}
                customerRefetch={refetch}
              />
            )}
          </TabPanel>
          <TabPanel />
        </div>
      </Tabs>
    </>
  );
};

function TabIcon({ svg }) {
  return <img draggable="false" src={svg} alt="icon" />;
}

Account.propTypes = {
  customer: PropTypes.object,
  token: PropTypes.string,
  error: PropTypes.any,
  handleLogout: PropTypes.func,
};

Account.defaultProps = {
  customer: null,
  token: null,
  error: null,
  handleLogout: null,
};

export default Account;
